import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'

// 3rd party dependencies
import InlineSvg from 'vue-inline-svg'

// Local Components
import VPhotoSwipe from '@/components/VPhotoSwipe.vue'

const app = createApp(App)

app.config.globalProperties.$axios = axios

app.component('InlineSvg', InlineSvg)
app.component('VPhotoSwipe', VPhotoSwipe)

app.directive('bg-image', (el, { value }) => {
  el.style.backgroundImage = `url('${value}')`
})

app.use(store)
app.use(router)
app.mount('#app')
